import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';
import { RouteEnum } from '/@/enums/routeEnum';

const admin: AppRouteModule = {
  path: RouteEnum.ADMIN,
  name: 'Admin',
  component: LAYOUT,
  redirect: `${RouteEnum.ADMIN}/users`,
  meta: {
    icon: 'ant-design:safety-outlined',
    title: '权限管理',
    orderNo: 90,
    // Surfaced only to users holding user:manage. Sidebar reads meta.permission via
    // the auth middleware added in P1.
    permission: 'user:manage',
  },
  children: [
    {
      // 数据看板(老板 2026-08-27 反馈 3/4):从 mainOut 独立整屏改挂全局
      // annotate LAYOUT 下,全局侧栏常驻;页面自身不再渲染内嵌侧栏。
      path: 'dashboard',
      name: 'AdminDashboard',
      component: () => import('/@/views/admin/dashboard/index.vue'),
      meta: {
        title: '数据看板',
        icon: 'ant-design:dashboard-outlined',
        permission: 'user:manage',
      },
    },
    {
      // 人员统计总览(老板 2026-09-13):标注员画框量 + 质检/审核裁定量
      path: 'stats',
      name: 'AdminStatsOverview',
      component: () => import('/@/views/admin/statsOverview/index.vue'),
      meta: {
        title: '统计总览',
        icon: 'ant-design:bar-chart-outlined',
        permission: 'user:manage',
      },
    },
    {
      // 创建标注项目(老板 2026-08-27 指示):与数据看板/用户管理同款,从
      // mainOut 独立整屏改挂全局 annotate LAYOUT,全局侧栏常驻;URL 保持
      // /admin/projects/new 不变(全局侧栏"创建项目"入口与主页 hero 按钮
      // 直跳该路径)。原 projects-new-link 重定向占位项由本真实路由取代,
      // 页面自身的内嵌侧栏/顶栏 chrome 已删,内容占满主区。
      path: 'projects/new',
      name: 'AdminCreateProject',
      component: () => import('/@/views/admin/createProject/index.vue'),
      meta: {
        title: '创建标注项目',
        icon: 'ant-design:plus-square-outlined',
        permission: 'user:manage',
      },
    },
    {
      // 用户管理:同样改挂 LAYOUT(老板 2026-08-27 反馈 3/4),
      // 原 mainOut 整屏路由已从 mainOut.ts 移除,避免路由名冲突。
      path: 'users',
      name: 'AdminUsers',
      component: () => import('/@/views/admin/users/index.vue'),
      meta: {
        title: '用户管理',
        icon: 'ant-design:team-outlined',
        permission: 'user:manage',
      },
    },
    {
      path: 'roles',
      name: 'AdminRoles',
      component: () => import('/@/views/admin/roles/index.vue'),
      meta: {
        title: '角色/权限',
        icon: 'ant-design:safety-certificate-outlined',
        permission: 'role:manage',
      },
    },
    {
      // M4 任务派单看板 — dispatch/recycle/transfer all carry the V3
      // permission code "task:assign" (ADMIN-only under the V4 four-role
      // mapping), so the page entry uses the same code.
      path: 'assignment',
      name: 'AdminAssignment',
      component: () => import('/@/views/admin/assignment/index.vue'),
      meta: {
        title: t('routes.assignment.assignment'),
        icon: 'ant-design:send-outlined',
        permission: 'task:assign',
      },
    },
    {
      // M4 申诉仲裁 — backend gates list/arbitrate with "data:audit" plus
      // an in-usecase ADMIN role check (no admin-exclusive code in V4).
      path: 'appeal',
      name: 'AdminAppeal',
      component: () => import('/@/views/admin/appeal/index.vue'),
      meta: {
        title: t('routes.appeal.arbitration'),
        icon: 'ant-design:audit-outlined',
        permission: 'data:audit',
      },
    },
    {
      // 数据审核工作台(老板 2026-08-27 拍板"界面统一"收尾):与数据看板/
      // 用户管理/创建项目同款,从 mainOut 独立整屏改挂全局 annotate LAYOUT,
      // 全局侧栏常驻;URL 保持 /admin/review/:dataId 不变(胶片条
      // $router.push('/admin/review/'+id)、我的任务与通知跳转均按该路径),
      // 页面自身的整屏深色外壳已删,内容占满主区。权限沿用 data:qc——QC 或
      // AUDIT 任一即可进入,细粒度校验在提交接口上(子路由 meta 覆盖父级
      // user:manage,路由守卫按 to.meta.permission 放行)。
      // 权限改数组(老板 2026-09-05 审计修复):守卫已支持 string|string[](任一
      // 命中放行),纯审核员(data:audit 无 data:qc)也能进审核工作台做终审。
      path: 'review/:dataId',
      name: 'AdminReview',
      component: () => import('/@/views/admin/review/index.vue'),
      meta: {
        title: '数据审核',
        icon: 'ant-design:audit-outlined',
        hideMenu: true,
        permission: ['data:qc', 'data:audit'],
      },
    },
  ],
};

export default admin;
